import { LOGIN, LOGIN_SUCCESS } from "../actions/actionTypes";
import updateObject from "../../utils/updateObject";


const initialState = {
    profile: {},
  };
  
  const userReducer = (state = initialState, { type, data }) => {
    switch (type) {
      
      case LOGIN:
        return updateObject(state, { profile: data });
      
      case LOGIN_SUCCESS:
        return updateObject(state, { profile: data });
      
      default:
        return state;
    }
};

export default userReducer;
